import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import { NewMessage as NewMessageV1 } from "./New_v1";
import { NewMessage as NewMessageV2 } from "./New_v2";

export const NewMessage = () => {
  const flags = useFlags(["ai-messaging-translation", "ai-messaging-polish"]);
  if (
    flags["ai-messaging-translation"].enabled ||
    flags["ai-messaging-polish"].enabled
  ) {
    return <NewMessageV2 />;
  }
  return <NewMessageV1 />;
};
